import {
    resultsTable,
    resultsTableHeaderTd, resultsTableTH,
} from './styles/ResultsTableView.styles'

import React from 'react'
import {ResultsTableProps} from './types'

import {styled} from 'stitches/config'
import {
    styledTR,
} from 'components/Table/styles/TableView'

const StyledTable = styled('table', resultsTable)
const StyledTR = styled('tr', styledTR)
const StyledResultsTableTH = styled('th', resultsTableTH)
const StyledResultsTableHeaderTd = styled('td', resultsTableHeaderTd)

const ResultsTableView = (props: ResultsTableProps) => {
    const {
        includeColumnNames = true, includeHeader = true, items, columns, headerText, Template, tabIndex,
    } = props

    return (
        <StyledTable>
            <thead>
                {includeHeader ?
                    <StyledTR>
                        <StyledResultsTableHeaderTd colSpan={columns?.length || 1}>
                            {headerText}
                        </StyledResultsTableHeaderTd>
                    </StyledTR>
                    : null}
                {includeColumnNames ?
                    <StyledTR>
                        {
                            columns?.map((col: string) => (
                                <StyledResultsTableTH key={col}>
                                    {col}
                                </StyledResultsTableTH>
                            ))
                        }
                    </StyledTR>
                    : null}
            </thead>
            <tbody>
                {items.map((item: ResultsTableProps['items'][number]) => (
                    <StyledTR key={item.id}>
                        <Template {...item} tabIndex={tabIndex} />
                    </StyledTR>
                ))}
            </tbody>
        </StyledTable>
    )
}

ResultsTableView.defaultProps = {
    includeColumnNames: true,
    includeHeader: true,
}

export default ResultsTableView

